var render = function render(){var _vm=this,_c=_vm._self._c;return _c('draggable',_vm._b({attrs:{"tag":"tbody","list":_vm.data.dataSource,"handle":".handle"},on:{"start":function($event){_vm.drag = true},"end":_vm.end}},'draggable',_vm.dragOptions,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }